module.exports = __webpack_public_path__ + "static/img/Patrick.Ryder.92a3eb1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Patrick.Ryder.jpg
// module id = S+Lt
// module chunks = 0